module.exports = __webpack_public_path__ + "media/images/connection-e87947f85adee71b61fd6084e4dfc464.png";